// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Zt3d","location":"Header_location__XB6ja"};